import React from 'react';
import '../../src/assets/css/loginAdmin.css';
 const LoginAdmin = () => {
   return (
    <>
    <section className="position-relative">        
        <div className="bg-video-wrapper"><br/>
                <br/>
                <iframe src="https://youtube.com/embed/XCQS5NE2xFY?controls=0&amp;rel=0&amp;autoplay=1&amp;loop=1&amp;mute=1&amp;playlist=XCQS5NE2xFY"></iframe>
            </div>
            <div className="bg-overlay bg-linear-gradient-2"></div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 p-0">
                        <div className="d-flex flex-column min-vh-100 p-4">
                            <div className="title-heading my-auto">
                                <div className="card form-signin px-4 py-5 rounded-md shadow-sm" style={{backgroundColor: "rgb(35 35 35 / 76%)"}}>
                                    <form className="needs-validation" method="POST" action="https://b2b.obsessionsgroup.com/login/admin" id="needs-validation">
                                        <input type="hidden" name="_token" value="hH4qPjnOEuu8wB9H9hJ8vv0WnGE6hVxGcCIWWcwA"/>                                     
                                           <div className="text-center">
                                            <img src="https://b2b.obsessionsgroup.com/public/login-assets/images/logo-white.svg" width="200" alt="obsessions"/>
                                        </div>
                                        <br/> 

                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="form-floating mb-2">
                                                    <input type="text" className="form-control" name="username" id="loginUsername" placeholder="Enter Login Username *" style={{ backgroundColor: "#fffefe45"}}/>
                                                    <label for="loginUsername" style={{color:"#FFF"}}>Username</label>
                                                </div>
                                           </div>

                                           <div className="col-lg-12">
                                                <button style={{color:"#5f6367", display:"none"}} id="ajax-loader" className="btn btn-primary login rounded-md w-100" type="button"><i className="fa fa-spinner fa-spin"></i> Logging...</button>
                                                <button id="login-btn" className="btn btn-primary login rounded-md w-100" type="button">Sign in With Mobile  </button>
                                            </div>

                                            <div className="col-lg-12">
                                                <button id="login-btn" className="btn btn-primary btn-primary-button login rounded-md w-100" type="button">Sign in With Email </button>
                                            </div>

                                            <div className="col-lg-12">
                                                <div className="d-flex justify-content-between">
                                                    <div className="mb-3">
                                                        <div className="form-check align-items-center d-flex mb-0 mt-2">
                                                            <input className="form-check-input mt-0" type="checkbox" value="1" id="remember"/>
                                                            <label className="form-check-label text-white ms-2" for="remember">Remember me</label>
                                                        </div>
                                                    </div>
                                                    <small className="text-muted mb-0 mt-2"><a href="https://b2b.obsessionsgroup.com/forgot-password" className="text-white" style={{ textDecoration: "none" }}>Forgot password ?</a></small>
                                                </div>
                                             </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
     </>
   )
 }
 export default LoginAdmin;  